import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { DeveloperService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';

@Component({
   selector: 'mnf-modal-accept-resources',
   templateUrl: './modal-accept-resources.component.html',
   styleUrls: ['./modal-accept-resources.component.scss']
})
export class ModalAcceptResourcesComponent implements OnInit {

   // Información del proyecto actual
   project: any;
   // Información del proyecto actual
   withdrawData: any;
   // Información de recursos aceptados
   resourcesAccepted = 0;
   // Saldo total de participaciones compradas
   activePartsTotal = 0;
   // Saldo total de participaciones restantes
   freePartsTotal = 0;
   // Monto disponible para aceptar
   pendingBalance: number;

   availableAcceptResources: boolean = false;

   public readonly urlBaseS3 = 'https://static.monific.com/assets/projects-images/';

   constructor(private dialogRef: MatDialogRef<any>, private modalServ: ModalService) { }

   ngOnInit(): void {
      // Calcular el monto disponible para aceptar
      this.freePartsTotal = this.withdrawData.phases.reduce((a, b) => a + (Number(b.partValue) * Number(b.free)), 0);
      this.activePartsTotal = this.withdrawData.phases.reduce((a, b) => a + (Number(b.partValue) * Number(b.active)), 0);
      this.resourcesAccepted = this.withdrawData.acceptedResources.reduce((a, b) => a + Number(b.amount), 0);
      // Almacenar en la variable global el monto restante por fondear
      this.pendingBalance = this.withdrawData.balance;
   }

   /** Función para aceptar recursos */
   acceptResources() {
      const infoAmount = {
         pid: this.project.pid,
         name: this.project.name,
         image: this.project.images[0] || this.project.gallery[0],
         iva: this.project.iva,
         commission: this.project.commission,
         clabe: this.project.clabe,
         baseProject: this.project.baseProject,
      };

      const m = this.modalServ.openModalConfirmResources(infoAmount);

      m.afterClosed().subscribe(r => {
         if (r) this.dialogRef.close(true);
      });
   }

   buildImageUrl(dev: any, urlBaseS3: string): string {
      let basePath = dev?.baseProject == null ? dev?.pid : dev?.baseProject;
      let imageUrl = dev?.images[0] || dev?.gallery[0];
      
      if (!imageUrl) {
        return '';
      }
    
      let fullUrl = urlBaseS3 + basePath + '/' + imageUrl;
      let urlParts = fullUrl.split("https://static.monific.com/assets/");
      if (urlParts.length > 2) {
        fullUrl = "https://static.monific.com/assets/" + urlParts.pop();
      }
    
      return fullUrl;
    }

   /** Función para cerrar el modal actual */
   close() {
      this.dialogRef.close();
   }

}
